import React from "react";
import { useSelector } from "react-redux";
import classes from "./Message.module.css";


const Message = ({ message }) => {
    const { lang } = useSelector(state => state.translate);

    let messageContent = message.contents && message.contents[lang]

    const handleClick = () => {
        if (messageContent?.link)
            window.location.href = messageContent.link
    }

    return (
        <div className={classes.Message} onClick={handleClick}>
            <div className={classes.MessageContent}>
                {message.isRead ? <></> : <div className={classes.RedMark}></div>}
                <div className={classes.Square} style={{ backgroundImage: message.messageType ? `url(${message.messageType?.icon})` : '' }}></div>
                <div className={classes.MessageText}>{messageContent.text}</div>
            </div>
            <div className={classes.Line}></div>
        </div>
    )
}

export default Message